<template>
  <article>
    <!-- 轮播图 -->
    <div ref="mySwiper" v-swiper:mySwiper="swiperOption" class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
          <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.picpath" oncontextmenu="return false;">
        </div>
      </div>
    </div>
    <!-- 品牌故事 -->
    <section id="home-two">
      <div class="wrapper">
        <!-- <div class="subhead fill" style="margin-top: 10px;">
          <span>品牌故事</span>
        </div> -->
        <div style="display: flex;justify-content: space-between;">
          <div>
            <div class="p1-box">
              <div style="line-height:40px;">
                <p v-html="getHistoryContant"></p>
              </div>
            </div>
          </div>
          <div id="videoContant">
            <video controls muted loop style="width: 90%;margin-top: 20px;">
              <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/b89bbc79cbfa805af28b7f39de46a9e3.mp4" type="video/mp4">
            </video>
          </div>
        </div>
        <div class="p1-box">
          <div class="pure-u-1 pure-u-xl-1-1">
            <div class="history">
              <div class="history-box" v-for="(item, index) in getHistory" :key="index">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" />
                <div>{{ item.imageTitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 公司简介 begin -->
    <!-- <section id="home-two">
      <div class="wrapper">
        <div class="subhead fill">
          <span>公司简介</span>
        </div>
        <div class="p1-box">
          <div class="intro" style="line-height:32px">
            <p style="white-space: pre-wrap;">
              河南嗨浪技术有限公司，秉承“实现亿万国人流量自由”的企业愿景，深耕物联网行业，目前主营产品是随身WiFi，我们自有技术、源头厂家，做到了研发-生产-销售-售后一站式运营。
              嗨浪公司运营中心总部在河南郑州，研发中心在深圳。
              我们拥有一支精英级技术团队，不断推动产品更新，以创新为驱动，确保嗨浪产品和服务处于行业前沿。
              我们拥有专业的售后服务团队，随时待命，解决设备和使用问题，确保用户无后顾之忧。
              我们拥有全维度强赋能的商学院，院长有近200家企业特聘首席战略顾问经验，提供线上线下的多方支持，解决合伙人的实际问题。
            </p>
          </div>
          <div class="banner">
            <div class="pure-g">
              <div class="pure-u-1-3 pure-u-xl-1-3">
                <div class="item">
                  <img src="https://swanair-website.oss-cn-beijing.aliyuncs.com/assets/images/index/qyjzg.png">
                  <span>企业价值观</span>
                  <p>嗨浪无极限，任你嗨翻天</p>
                </div>
              </div>
              <div class="pure-u-1-3 pure-u-xl-1-3">
                <div class="item">
                  <img src="https://swanair-website.oss-cn-beijing.aliyuncs.com/assets/images/index/qyyj.png">
                  <span>企业愿景</span>
                  <p>实现亿万国人的流量自由</p>
                </div>
              </div>
              <div class="pure-u-1-3 pure-u-xl-1-3">
                <div class="item">
                  <img src="https://swanair-website.oss-cn-beijing.aliyuncs.com/assets/images/index/jyln.png">
                  <span>企业使命</span>
                  <p>务实、创新、团结、拼搏</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- 公司简介 end -->

    <!-- <div id="home-one-mobile" @click="$router.push('/profile/history')">
      <img src="https://swanair-website.oss-cn-beijing.aliyuncs.com/assets/images/mobile/timeline-bg.png">
    </div> -->

    <!-- 应用场景 -->
    <!-- <section id="home-three">
      <div class="wrapper">
        <div class="subhead">
          <span>应用场景</span>
        </div>
        <div class="banner">
          <div class="pure-g">
            <div class="pure-u-1-3 pure-u-xl-1-3">
              <div class="item">
                <img src="../assets/applyTo/1.jpg">
                <span>应用场景</span>
                <p>E-commerce</p>
              </div>
            </div>
            <div class="pure-u-1-3 pure-u-xl-1-3">
              <div class="item">
                <img src="../assets/applyTo/2.jpg">
                <span>应用场景</span>
                <p>Hotel field</p>
              </div>
            </div>
            <div class="pure-u-1-3 pure-u-xl-1-3">
              <div class="item">
                <img src="../assets/applyTo/3.jpg">
                <span>应用场景</span>
                <p>Hotel field</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- 应用场景 end -->

    <!-- 新闻中心 -->
    <!-- <section id="home-four">
      <div class="wrapper">
        <div class="subhead fill">
          <span>新闻中心</span>
        </div>
        <div class="p1-box">
          <div class="carousel">
            <el-carousel :height="carouselType == 'card' ? '350px' : '280px'" :interval="40000" indicator-position="none"
              :type="carouselType">
              <el-carousel-item v-for="(item, index) in xinwenImgList" :key="index">
                <div class="picture"
                  :style="'height: ' + (carouselType == 'card' ? '350px' : '280px') + ';background: url(' + item.imgpath + ') no-repeat center'">
                </div>
                <div class="title">{{ item.topicdescribe }}</div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="btn-box">
          <button class="pure-button" @click="$router.push('/news')">查看更多</button>
        </div>
      </div>
    </section> -->
    <!-- 新闻中心 end -->

    <!-- 企业文化 begin -->
    <section id="top-pro" class="qywh">
      <div class="wrapper">
        <div class="subhead">
          <span>企业文化</span>
        </div>
        <div class="p1-box">
          <div class="qiyewenhua-bg">
            <div style="display: flex;justify-content: space-between;">
              <div class="getImage-box">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + enterprise[0].imageUrl"
                  oncontextmenu="return false;">
              </div>
              <div class="getImage-box" style="margin-left: 30px;">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + enterprise[1].imageUrl"
                  oncontextmenu="return false;">
              </div>
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 30px;">
              <div class="getImage-box">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + enterprise[2].imageUrl"
                  oncontextmenu="return false;">
              </div>
              <div class="getImage-box" style="margin-left: 30px;">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + enterprise[3].imageUrl"
                  oncontextmenu="return false;">
              </div>
              <div class="getImage-box" style="margin-left: 30px;">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + enterprise[4].imageUrl"
                  oncontextmenu="return false;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 企业文化 end -->

    <!-- 合作伙伴 begin -->
    <section id="home-five">
      <div class="wrapper">
        <div class="subhead">
          <span>合作伙伴</span>
        </div>
        <div class="p1-box" style="display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;">
          <div style="width: 11%;margin-top: 20px;" v-for="(item, index) in partner" :key="index">
            <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" />
          </div>
        </div>
      </div>
    </section>
    <!-- 合作伙伴 end -->

    <!-- 首页动画 begin -->
    <!-- <div class="startup-animation" @touchmove.prevent v-if="startupAnimation">
      <div class="gif" v-if="isMobile"></div>
      <video-player :playsinline="true" :options="playerOptions" v-else></video-player>
      <audio ref="bgm" autoplay loop :src="startupBGM" hidden></audio>
      <div class="close">
        <i class="icon" @click="startupAnimation = false"></i>
      </div>
    </div> -->
    <!-- 首页动画 end -->
  </article>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      // 轮播图
      curLunbo: 3,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // loop: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768 
            slidesPerView: 1,
            spaceBetween: 3
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 1,
            spaceBetween: 3
          },
          1440: {  //当屏幕宽度大于等于1440
            slidesPerView: 1,
            spaceBetween: 3
          },
          1920: {  //当屏幕宽度大于等于1920
            slidesPerView: 1,
            spaceBetween: 3
          }
        }
      },
      swiperList: [],
      // 品牌故事
      getHistoryContant: '',
      getHistory: [],
      // 企业文化
      enterprise: [],
      // 合作伙伴
      partner: [],







      tlIndex: 9,
      company: {},
      isMobile: document.body.clientWidth < 1280 ? true : false,
      startupBGM: "https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/5fb86e2c-e730-4c08-8ffb-d1fcf27713f8.mp4",
      startupAnimation: true,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: true,
        loop: true,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "https://swanair-website.oss-cn-beijing.aliyuncs.com/assets/startup.mp4"
          }
        ],
        poster: "",
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: false
      },
      carouselType: "card",
      startShow: false,
      enterShow: true,
      timeIndex: 3,
      xinwenImgList: [], //新闻中心
      fourTimeLineList: [],
      timeLineList: [],
      companyHistoryList: [],
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    // 获取轮播图
    this.getSwiperList()
    // 品牌故事、企业文化、合作伙伴
    this.brandHistory()






    let timestamp = Date.parse(new Date());
    let startup = Number(localStorage.getItem("startup"));
    if (startup) {
      if (timestamp > (startup + 3600000)) {
        this.startupAnimation = true;
        localStorage.setItem("startup", timestamp);
      } else {
        this.startupAnimation = false;
      }
    } else {
      localStorage.setItem("startup", timestamp);
    }
    // document.body.style.overflow = "hidden";
    this.carouselType = document.body.clientWidth < 1280 ? "horizontal" : "card";
  },
  mounted() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger') > -1) {
      document.addEventListener("WeixinJSBridgeReady", () => {
        this.$refs.bgm.play();
      }, false)
    }
    window.addEventListener("resize", () => {
      this.isMobile = document.body.clientWidth < 1280 ? true : false;
    });
  },
  methods: {
    // 获取轮播图
    getSwiperList() {
      this.$http.get("/shopping/library/phoneList", {
        pictype: "3"
      }, res => {
        if (res.code == '200') {
          this.swiperList = res.data
          setInterval(() => {
            this.curLunbo += 1
            if (this.curLunbo >= this.swiperList.length) {
              this.curLunbo = 0
            }
            this.swiper.slideTo(this.curLunbo, 2000, false)
          }, 3000)
        }
      })
    },
    // 品牌故事、企业文化、合作伙伴
    brandHistory() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "1"
      }, res => {
        if (res.code == '200') {
          this.getHistoryContant = res.data.品牌故事[3][0].content
          this.getHistory = res.data.品牌故事[1]
          this.enterprise = res.data.企业文化[1]
          this.partner = res.data.合作伙伴[1]
        }
      })
    },




    onEnter() {
      this.startShow = false
      this.enterShow = false
    },
    onPlayerPlay() {
      let myPlayer = this.$refs.videoPlayer.player
      myPlayer.play()
    },
    onPlayerEnded() {
      this.startShow = false
      this.enterShow = false
    },
    onStart() {
      let vm = this
      vm.startShow = true
      this.onPlayerPlay(this.$refs.videoPlayer.player)
    },
    moveLeft() {
      if (this.timeIndex == this.timeLineList.length - 1) {
        return false
      } else {
        this.timeIndex += 1
        this.fourTimeLineList.splice(0, 1)
        this.fourTimeLineList.push(this.timeLineList[this.timeIndex])
      }
    },
    moveRight() {
      if (this.timeIndex == 3) {
        return false
      } else {
        this.timeIndex -= 1
        this.fourTimeLineList.splice(this.fourTimeLineList.length - 1, 1)
        this.fourTimeLineList.splice(0, 0, this.timeLineList[this.timeIndex - 3])
      }
    },
    tlLeft() {
      if (this.tlIndex > 0) {
        this.tlIndex = this.tlIndex - 1;
        this.fourTimeLineList = [];
        this.companyHistoryList.forEach((item, index) => {
          if (index >= this.tlIndex && index < (this.tlIndex + 4)) {
            this.fourTimeLineList.push(item);
          }
        })
      }
    },
    tlRight() {
      console.log(this.tlIndex);
      if (this.companyHistoryList.length >= this.tlIndex + 5) {
        this.tlIndex = this.tlIndex + 1;
        this.fourTimeLineList = [];
        this.companyHistoryList.forEach((item, index) => {
          if (index >= this.tlIndex && index < (this.tlIndex + 4)) {
            this.fourTimeLineList.push(item);
          }
        })
      }
    }
  },
  watch: {
    startupAnimation(newVal, oldVal) {
      if (newVal === false)
        document.body.style.overflow = "auto";
    }
  }
};
</script>

<style scoped>
.history {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.history-box {
  padding: 20px;
  text-align: center;
  box-shadow: 1px 1px 29px 0px rgb(185 185 185 / 26%);
  border: 1px solid rgba(255, 255, 255, 100);
  border-radius: 10px;
  margin-top: 30px;
  transition: transform 0.3s;
  /* 平滑过渡效果 */
  transform: scale(1);
  /* 初始缩放比例 */
}

.history-box:hover {
  transform: scale(1.1);
  /* 鼠标点击时的缩放比例 */
}

.history-box>img {
  width: 64px;
  height: 64px;
  padding: 20px;
}</style>
